export default {
  name: 'GcHeading',
  props: {
    content: {
      type: String,
      default: '',
    },
    headingSize: {
      type: String,
      default: 'h1',
    },
    theme: {
      type: String,
      default: 'light',
    },
    alignment: {
      type: String,
      default: 'left',
    },
    styleObject: {
      type: Object,
      default: null,
    },
  },
};
